// // ONLY way to FIX react quill is this :

// export const quillFix = (text) => {
//   let slicedText = text.replace('<p><br></p>', '').trim();
//   slicedText = slicedText.replaceAll('<p><br></p>', '').trim();
//   slicedText = slicedText.replace(/<p>(?!.*<\/p>)/, '');
//   slicedText = slicedText.replace(/<\/p>/g, '<br>');
//   slicedText = slicedText.replaceAll(/<p>/g, '');
//   return slicedText;
// };

export const quillFix = (text) => {
  if (!text) return '';

  let clean = text;

  clean = clean.replace(/^(?:\s*<p><br><\/p>)+/, '');

  clean = clean.replace(/^((\s|<br>)+)?(?=<h[1-6]>)/, '');

  clean = clean.replace(/(<p><br><\/p>)+/g, (match) => {
    const count = (match.match(/<p><br><\/p>/g) || []).length;
    return '<br>'.repeat(count);
  });

  clean = clean.replace(/<p>(.*?)<\/p>/g, '$1<br>');

  clean = clean.replace(/(<br>\s*)+$/, '');

  console.log('clean Text', clean);
  return clean;
};




